import type { NotificationsState } from './state'
import type { Notification, NotificationGroup } from '@/types'
import {
  NOTIFICATION_TYPE_TO_CATEGORY,
  NOTIFICATION_CATEGORY_TO_GROUP,
  NOTIFICATION_GROUP_LABELS,
  NOTIFICATION_GROUP_ORDER,
} from '@/types'

export interface NotificationGroupData {
  group: NotificationGroup
  label: string
  notifications: Notification[]
  unreadCount: number
}

export const getters = {
  unreadCount: (state: NotificationsState): number => {
    return state.notifications.filter((n) => !n.isRead).length
  },

  hasUnread: (state: NotificationsState): boolean => {
    return state.notifications.some((n) => !n.isRead)
  },

  unreadNotifications: (state: NotificationsState): Notification[] => {
    return state.notifications.filter((n) => !n.isRead)
  },

  readNotifications: (state: NotificationsState): Notification[] => {
    return state.notifications.filter((n) => n.isRead)
  },

  groupedNotifications: (state: NotificationsState): NotificationGroupData[] => {
    const groupMap = new Map<NotificationGroup, Notification[]>()

    for (const notification of state.notifications) {
      const category = NOTIFICATION_TYPE_TO_CATEGORY[notification.type]
      const group = category ? NOTIFICATION_CATEGORY_TO_GROUP[category] : 'support'
      if (!groupMap.has(group)) {
        groupMap.set(group, [])
      }
      groupMap.get(group)!.push(notification)
    }

    return NOTIFICATION_GROUP_ORDER
      .filter((group) => groupMap.has(group))
      .map((group) => {
        const notifications = groupMap.get(group)!
        return {
          group,
          label: NOTIFICATION_GROUP_LABELS[group],
          notifications,
          unreadCount: notifications.filter((n) => !n.isRead).length,
        }
      })
  },
}
